let lastUniqueId = 0;

function classToggler(toggleSelector, cssClass, parentSelector, preToggle = null, postToggle = null) {
  document.querySelectorAll(toggleSelector).forEach(el => {
    const parent = el.closest(parentSelector);
    if (!parent) { return; }
    
    const fnToggle = (isOn) => {
      preToggle && preToggle(isOn, el, parent, fnToggle);
      parent.classList.toggle(cssClass, isOn);
      postToggle && postToggle(isOn, el, parent, fnToggle);
    };
  
    el.addEventListener('click', function(e) {
      e.preventDefault();
      const isOn = parent.classList.contains(cssClass);
      
      fnToggle(!isOn);
    });
  });
}

function uniqueId() {
  return 'nst-uniq-' + (lastUniqueId++);
}

function forceReflow(el) {
  void(el.offsetHeight);
}

function clearNode(el) {
  el.textContent = '';
}

function safeDeepClone(el) {
  const clone = el.cloneNode(true);
  clone.removeAttribute('id');
  return clone;
}

function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

/**
 * Prepares an element for a transition from/to "display:none", allowing the
 * transition to be fully displayed, then removing it once it's complete.
 *
 * Sets style='display: <value>' on the element itself.  This override remains until
 * the element receives a transitionend, transitioncancel, animationend, or animationcancel event.
 *
 * @param display string The transitional display property value.  Generally this will be the display value when the the element is fully visible
 */
function prepDisplayNoneTransition(el, display = 'block') {
  transitionBookend(el, 
    () => { el.style.display = display; forceReflow(el); },
    () => (el.style.display = none)
  );
}

function setClassDuringTransition(el, className, transitionEnd) {
  transitionBookend(el, 
    () => el.classList.add(className), 
    () => { el.classList.remove(className); transitionEnd && transitionEnd(); }
  );
}

function transitionBookend(el, fnStart, fnEnd) {
  if (el.nst_transitionBookendHandler) { return; }
   
  const transitionHandler = () => {
    el.removeEventListener('transitionend', transitionHandler);
    el.removeEventListener('transitioncancel', transitionHandler);
    el.removeEventListener('animationend', transitionHandler);
    el.removeEventListener('animationcancel', transitionHandler);
    el.nst_transitionBookendHandler = null;
    fnEnd();
  };
  
  el.nst_transitionBookendHandler = transitionHandler;
  el.addEventListener('transitionend', transitionHandler);
  el.addEventListener('transitioncancel', transitionHandler);
  el.addEventListener('animationend', transitionHandler);
  el.addEventListener('animationcancel', transitionHandler);
  fnStart();
}

export default {
  classToggler,
  clearNode,
  forceReflow,
  isTouchDevice,
  prepDisplayNoneTransition,
  safeDeepClone,
  setClassDuringTransition,
  transitionBookend,
  uniqueId
};